export async function downloadFileWithoutExtension(url:string) {
    try {
      const fileUrl = new URL(url);
      const fileName = decodeURIComponent(fileUrl.pathname.split('/')[2]);
      const ext = fileUrl.pathname.split('/')[2].split('.')[1];
      if(!ext) {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName + `.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } else {
        window.open(url, "_blank")
      }
    } catch (e) {
      console.error('Download failed', e);
    }
  }